import { render, staticRenderFns } from "./PuzzleWallsCreate.vue?vue&type=template&id=6130d5d1&"
import script from "./PuzzleWallsCreate.vue?vue&type=script&lang=js&"
export * from "./PuzzleWallsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports